import React, { useState, useEffect, useContext } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import Select from "react-select";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { EmailAuthContext } from "../../../core/common/context/EmailAuthContext";
import { useDispatch, useSelector } from "react-redux";
import {
  profileEvents,
  addOrUpdateMeeting,
  deleteMeeting,
} from "../../../core/data/redux/slices/EventSlice";
import { showToast } from "../../../core/data/redux/slices/ToastSlice";
// import { setSelectedContact } from "../../../core/data/redux/slices/SelectedContactSlice\";
import api from "../../../core/axios/axiosInstance";
import dayjs from "dayjs";
import { DatePicker, TimePicker, Modal } from "antd";
import { all_routes } from "../../router/all_routes";
// import { saveContact } from "../../../core/data/redux/slices/ContactSlice";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useDebounce } from "../../../core/hooks/useDebounce";
import "./calendar.css";

const Calendar = () => {
  const [startDate, setDate] = useState(new Date()),
    [showCategory, setshowCategory] = useState(false),
    [showmodel, setshowmodel] = useState(false),
    [showEvents, setshowEvents] = useState(false),
    [show, setshow] = useState(false),
    [iseditdelete, setiseditdelete] = useState(false),
    [addneweventobj, setaddneweventobj] = useState(null),
    [isnewevent, setisnewevent] = useState(false),
    [event_title, setevent_title] = useState(""),
    [category_color, setcategory_color] = useState(""),
    [calenderevent, setcalenderevent] = useState(""),
    [allContacts, setAllContacts] = useState([]),
    [weekendsVisible, setWeekendsVisible] = useState(true),
    [currentEvents, setscurrentEvents] = useState([]);
  const [defaultEvents, setDefaultEvents] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoadingContacts, setIsLoadingContacts] = useState(false);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(today.format("YYYY-MM-DD"));

  const userProfile = useSelector((state) => state.profile);
  const eventsState = useSelector((state) => state.event);
  const events = eventsState?.data || eventsState || [];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [meetingFormData, setMeetingFormData] = useState({
    meeting_id: "",
    meetingDescription: "",
    meetingTitle: "",
    meetingStartDate: dayjs(),
    meetingStartTime: dayjs("00:00:00", "HH:mm:ss"),
  });
  const getFormattedDate = (startTime) => {
    const fmstring = dayjs(startTime, "HH:mm").format("hh:mm A");
    if (!fmstring || fmstring === "Invalid Date") {
      return "No time specified";
    }
    return fmstring;
  };
  const location = useLocation();
  const isCalendar = location.pathname.includes("calendar");
  dayjs.extend(customParseFormat);
  const route = all_routes;
  useEffect(() => {
    setDefaultEvents(events);
  }, [events]);

  useEffect(() => {
    // Fetch both contact and lead events in a single call
    dispatch(profileEvents());
  }, [dispatch]);

  // Fetch contacts and leads with search functionality
  const fetchContactsAndLeads = async (search = "") => {
    try {
      setIsLoadingContacts(true);
      const params = search ? { search } : {};
      const response = await api.get("/getAllContactsOrLeads/ForEvent", {
        params,
      });

      const transformed = response.data.data.map((item) => {
        const name = `${item.firstname || ""} ${item.lastname || ""}`.trim();
        const email = item.emailAddresses?.[0] || "";
        const categoryLabel = item.category === "lead" ? "Lead" : "Contact";
        return {
          value: item.id,
          label: email
            ? `${name} (${email}) - ${categoryLabel}`
            : `${name} - ${categoryLabel}`,
          category: item.category,
        };
      });
      console.log(transformed, "transformed contacts and leads");
      setAllContacts(transformed);
    } catch (error) {
      console.log(
        error.response?.data?.message || "Error fetching contacts and leads"
      );
    } finally {
      setIsLoadingContacts(false);
    }
  };

  // Debounced search effect - only fetch when there's a meaningful search query
  useEffect(() => {
    if (debouncedSearchQuery && debouncedSearchQuery.trim().length >= 1) {
      fetchContactsAndLeads(debouncedSearchQuery);
    } else {
      // Clear contacts when search is too short or cleared
      setAllContacts([]);
    }
  }, [debouncedSearchQuery]);

  const handleMeetingSubmit = async () => {
    // Validation
    if (!meetingFormData.meetingTitle?.trim()) {
      dispatch(
        showToast({
          message: "Meeting title is required",
          variant: "danger",
        })
      );
      return;
    }

    if (!meetingFormData.meetingDescription?.trim()) {
      dispatch(
        showToast({
          message: "Meeting description is required",
          variant: "danger",
        })
      );
      return;
    }

    if (!selectedOption) {
      dispatch(
        showToast({
          message: "Please select a contact or lead",
          variant: "danger",
        })
      );
      return;
    }

    // Prepare meeting data - force offline type
    const meetingData = {
      contact_id: selectedOption.value,
      category: selectedOption.category,
      meetingTitle: meetingFormData.meetingTitle,
      meetingDescription: meetingFormData.meetingDescription,
      meetingStartDate: meetingFormData.meetingStartDate.format("YYYY-MM-DD"),
      meetingStartTime: meetingFormData.meetingStartTime.format("HH:mm"),
      meetingType: "offline",
    };

    // Add meeting_id if updating
    if (meetingFormData.meeting_id) {
      meetingData.meeting_id = meetingFormData.meeting_id;
    }

    console.log("Submitting meeting data:", meetingData);

    try {
      await dispatch(addOrUpdateMeeting(meetingData)).unwrap();

      // Refresh events for calendar
      dispatch(profileEvents());

      // Reset form and close modal
      resetMeetingForm();
      try {
        const modalEl = document.getElementById("add_meeting");
        if (modalEl) {
          const bsModal =
            window.bootstrap?.Modal.getInstance(modalEl) ||
            new window.bootstrap.Modal(modalEl);
          bsModal.hide();
        }
      } catch (err) {
        // ignore modal hide errors
      }
    } catch (error) {
      console.error("Error saving meeting:", error);
    }
  };

  const handleEditMeeting = (event) => {
    // Populate form with meeting data
    setMeetingFormData({
      meeting_id: event.event_id,
      meetingTitle: event.title,
      meetingDescription: event.description || "",
      meetingStartDate: dayjs(event.start),
      meetingStartTime: dayjs(event.startTime, "HH:mm"),
    });

    // Set selected contact/lead directly from event data
    if (event.contact_id && event.contact_name) {
      const contactOption = {
        value: event.contact_id,
        label: `${event.contact_name} (${
          event.contact_email || "No Email"
        }) - ${event.category === "lead" ? "Lead" : "Contact"}`,
        category: event.category || "contact",
      };
      setSelectedOption(contactOption);

      // Add this contact to allContacts so it appears in the dropdown
      setAllContacts([contactOption]);
    }
  };

  const handleDeleteMeeting = async (event) => {
    Modal.confirm({
      title: "Delete Meeting",
      content: `Are you sure you want to delete "${event.title}"?`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      centered: true,
      onOk: async () => {
        try {
          await dispatch(
            deleteMeeting({
              contact_id: event.contact_id,
              meeting_id: event.event_id,
              category: event.category || "contact",
            })
          ).unwrap();

          // Refresh events
          dispatch(profileEvents());
          // Reset form in case modal was open
          resetMeetingForm();
          try {
            const modalEl = document.getElementById("add_meeting");
            if (modalEl) {
              const bsModal =
                window.bootstrap?.Modal.getInstance(modalEl) ||
                new window.bootstrap.Modal(modalEl);
              bsModal.hide();
            }
          } catch (err) {
            // ignore
          }
        } catch (error) {
          console.error("Error deleting meeting:", error);
        }
      },
    });
  };

  const handleMeetingInputChange = (name, value) => {
    setMeetingFormData({
      ...meetingFormData,
      [name]: value,
    });
  };
  const handleChange = (option) => {
    console.log("Selected Contact:", option);
    setSelectedOption(option);
  };

  const handleSearchChange = (inputValue) => {
    setSearchQuery(inputValue);
  };

  const resetMeetingForm = () => {
    setMeetingFormData({
      meeting_id: "",
      meetingDescription: "",
      meetingTitle: "",
      meetingStartDate: dayjs(),
      meetingStartTime: dayjs("00:00:00", "HH:mm:ss"),
    });
    setSelectedOption(null);
    setSearchQuery("");
    // Clear contacts list so previous search/result doesn't persist
    setAllContacts([]);
  };
  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("width-100"));
  }, []);

  const [currentMonth, setCurrentMonth] = useState(dayjs());

  const getCalendarGrid = () => {
    const startOfMonth = currentMonth.startOf("month");
    const endOfMonth = currentMonth.endOf("month");
    const startDay = startOfMonth.startOf("week");
    const endDay = endOfMonth.endOf("week");
    const days = [];
    let day = startDay;
    while (day.isBefore(endDay) || day.isSame(endDay, "day")) {
      days.push(day);
      day = day.add(1, "day");
    }
    return days;
  };

  const eventsByDate = Array.isArray(events)
    ? events?.reduce((acc, event) => {
        const date = dayjs(event.start).format("YYYY-MM-DD");
        if (!acc[date]) acc[date] = [];
        acc[date].push(event);
        return acc;
      }, {})
    : {};

  const days = getCalendarGrid();

  return (
    <>
      <div className={isCalendar ? "page-wrapper" : ""}>
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card ">
                <div className="card-header mb-4">
                  {/* <div className="page-header"> */}
                  <div className="row align-items-center w-100">
                    <div className="col-lg-10 col-sm-12">
                      <h3 className="page-title">
                        {isCalendar ? "Calendar" : ""}
                      </h3>
                    </div>
                    <div className="col-lg-2 col-sm-12 d-flex justify-content-end p-0">
                      <Link
                        to="#"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#add_meeting"
                        onClick={resetMeetingForm}
                      >
                        Create Event
                      </Link>
                    </div>
                  </div>
                </div>
                {/* </div> */}
                <div className="row">
                  <div className="col-12 col-md-6 order-2 order-md-1">
                    {selectedDate && (
                      <div className="selected-events mt-6 ps-4">
                        <h5 className="text-lg font-semibold mb-3 text-gray-700 ">
                          Events on {dayjs(selectedDate).format("DD MMM YYYY")}
                        </h5>

                        {eventsByDate[selectedDate]?.length > 0 ? (
                          <div
                            style={{
                              height: "430px",
                              overflow: "auto",
                              overflowX: "hidden"
                            }}
                          >
                            {eventsByDate[selectedDate].map((event) => (
                              <div
                                key={event.event_id}
                                className="card border-start border-primary border-3 mb-3 shadow-sm"
                                style={{ borderRadius: "8px" }}
                              >
                                <div className="card-body p-3">
                                  {/* Header with time and actions */}
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div className="d-flex align-items-center gap-2">
                                      <i
                                        className="ti ti-clock text-primary"
                                        style={{ fontSize: "18px" }}
                                      ></i>
                                      <span className="fw-semibold text-primary">
                                        {getFormattedDate(event.startTime)}
                                      </span>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <button
                                        className="btn btn-sm btn-light p-1"
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                        }}
                                        onClick={() => handleEditMeeting(event)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#add_meeting"
                                        title="Edit Meeting"
                                      >
                                        <i
                                          className="ti ti-edit"
                                          style={{ fontSize: "16px" }}
                                        ></i>
                                      </button>
                                      <button
                                        className="btn btn-sm btn-light p-1"
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                        }}
                                        onClick={() =>
                                          handleDeleteMeeting(event)
                                        }
                                        title="Delete Meeting"
                                      >
                                        <i
                                          className="ti ti-trash text-danger"
                                          style={{ fontSize: "16px" }}
                                        ></i>
                                      </button>
                                    </div>
                                  </div>

                                  {/* Meeting title */}
                                  <h6 className=" fw-bold text-dark mb-3">
                                    {event.title}
                                  </h6>

                                  {/* Contact/Lead info */}
                                  <div className="d-flex align-items-center gap-2 mb-2">
                                    <i
                                      className="ti ti-user"
                                      style={{
                                        fontSize: "16px",
                                        color: "#6c757d",
                                      }}
                                    ></i>
                                    <span className="text-muted small">
                                      {event.contact_name || "Unknown"}
                                    </span>
                                    <span
                                      className={`badge ${
                                        event.category === "lead"
                                          ? "bg-info"
                                          : "bg-success"
                                      } ms-auto`}
                                      style={{
                                        fontSize: "10px",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      {event.category === "lead"
                                        ? "Lead"
                                        : "Contact"}
                                    </span>
                                  </div>

                                  {/* Description */}
                                  {event.description && (
                                    <p
                                      className="text-muted small mb-0"
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                      }}
                                    >
                                      {event.description}
                                    </p>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-gray-500 italic">No events</p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="col-12 col-md-6 order-1 order-md-2">
                    <div className="custom-calendar-wrapper mb-4">
                      <div className="calendar-header">
                        <div
                          onClick={() =>
                            setCurrentMonth(currentMonth.subtract(1, "month"))
                          }
                          className="calendar-nav"
                        >
                          {"<"}
                        </div>
                        <span>{currentMonth.format("MMMM YYYY")}</span>
                        <div
                          onClick={() =>
                            setCurrentMonth(currentMonth.add(1, "month"))
                          }
                          className="calendar-nav"
                        >
                          {">"}
                        </div>
                      </div>
                      <div className="calendar-grid">
                        {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((d) => (
                          <div
                            className="calendar-cell calendar-cell-header"
                            key={d}
                          >
                            {d}
                          </div>
                        ))}
                        {/* {days.map((day, idx) => {
                    const isCurrentMonth = day.month() === currentMonth.month();
                    const isToday = day.isSame(today, "day");
                    const dayEvents =
                      eventsByDate[day.format("YYYY-MM-DD")] || [];
                    return (
                      <div
                        key={idx}
                        className={`calendar-cell${
                          isCurrentMonth ? "" : " calendar-cell-outside"
                        }${isToday ? " calendar-cell-today" : ""}`}
                      >
                        <div className="calendar-date">{day.date()}</div>
                        {dayEvents.length > 0 && (
                          <div
                            className={`calendar-event-indicator`}
                            style={{
                              backgroundColor: isToday ? "white" : "",
                            }}
                          />
                        )}
                      </div>
                    );
                  })} */}
                        {days.map((day, idx) => {
                          const isCurrentMonth =
                            day.month() === currentMonth.month();
                          const isToday = day.isSame(today, "day");
                          const isSelected =
                            day.format("YYYY-MM-DD") === selectedDate;
                          const dayEvents =
                            eventsByDate[day.format("YYYY-MM-DD")] || [];

                          return (
                            <div
                              key={idx}
                              className={`calendar-cell${
                                isCurrentMonth ? "" : " calendar-cell-outside"
                              }${isToday ? " calendar-cell-today" : ""}${
                                isSelected ? " calendar-cell-selected" : ""
                              }`}
                              onClick={() =>
                                setSelectedDate(day.format("YYYY-MM-DD"))
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <div className="calendar-date">{day.date()}</div>
                              {dayEvents.length > 0 && (
                                <div
                                  className={`calendar-event-indicator`}
                                  style={{
                                    backgroundColor: isToday ? "white" : "",
                                  }}
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade modal-padding"
        id="add_meeting"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {meetingFormData.meeting_id
                  ? "Edit Meeting"
                  : "Add New Meeting"}
              </h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetMeetingForm}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="col-form-label">
                    Title <span className="text-danger"> *</span>
                  </label>
                  <input
                    className="form-control"
                    name="meetingTitle"
                    value={meetingFormData.meetingTitle}
                    onChange={(e) => {
                      handleMeetingInputChange(e.target.name, e.target.value);
                    }}
                    type="text"
                  />
                </div>

                <div className="mb-3">
                  <label className="col-form-label">
                    Description <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    name="meetingDescription"
                    value={meetingFormData.meetingDescription}
                    onChange={(e) =>
                      handleMeetingInputChange(e.target.name, e.target.value)
                    }
                  />
                </div>

                <div
                  className="mb-3"
                  style={{ zIndex: 9999, position: "relative" }}
                >
                  <label className="col-form-label">
                    Select Contact <span className="text-danger"> *</span>
                  </label>
                  <Select
                    value={selectedOption}
                    className="select2"
                    options={allContacts}
                    name="allContacts"
                    onChange={handleChange}
                    onInputChange={handleSearchChange}
                    placeholder="Search and select contact..."
                    classNamePrefix="react-select"
                    isSearchable={true}
                    isDisabled={!!meetingFormData.meeting_id}
                    isLoading={isLoadingContacts}
                    loadingMessage={() => "Searching contacts..."}
                    noOptionsMessage={() => {
                      if (!searchQuery || searchQuery.trim().length < 1) {
                        return "Type at least 1 character to search contacts";
                      }
                      return "No contacts found";
                    }}
                    filterOption={null} // Disable client-side filtering since we're doing server-side search
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                    menuPortalTarget={document.body}
                  />
                </div>

                <div
                  className="row"
                  style={{ zIndex: 1, position: "relative" }}
                >
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">Start Date</label>
                    <div className="icon-form-end">
                      <span className="form-icon">
                        <i className="ti ti-calendar-event" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker deals-details"
                        value={meetingFormData.meetingStartDate}
                        name="meetingStartDate"
                        onChange={(date) => {
                          handleMeetingInputChange("meetingStartDate", date);
                        }}
                        format="DD-MM-YYYY"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="col-form-label">Start Time </label>
                    <div className="icon-form">
                      <span className="form-icon">
                        <i className="ti ti-clock-hour-10" />
                      </span>
                      <TimePicker
                        placeholder="Select Time"
                        className="form-control datetimepicker-time"
                        name="meetingStartTime"
                        onChange={(time) =>
                          handleMeetingInputChange("meetingStartTime", time)
                        }
                        value={meetingFormData.meetingStartTime}
                        defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
                        format="hh:mm A"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 text-end modal-btn mt-4">
                  <Link
                    to="#"
                    className="btn btn-light"
                    data-bs-dismiss="modal"
                    id="closeMeetingModal"
                    onClick={resetMeetingForm}
                  >
                    Cancel
                  </Link>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleMeetingSubmit}
                  >
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Calendar;
